import React, { useState } from 'react'

import { isUrlImage } from '@/utils/common'
import { WALLET_ICONS } from '@/utils/constants'

interface TokenIconProps {
  symbol?: string
  className?: string
  name?: string
}

const TokenIcon: React.FC<TokenIconProps> = ({ symbol, className = 'size-8', name = 'Optimex' }) => {
  if (!symbol) return ''
  const [imageLoaded, setImageLoaded] = useState(false)

  const handleImageLoad = () => {
    setImageLoaded(true)
  }

  const renderImage = (src: string, alt: string) => {
    return (
      <div>
        <img
          src={src}
          className={`bg-dark-3 ${className} ${!imageLoaded ? 'hidden' : ''}`}
          alt={alt}
          onLoad={handleImageLoad}
        />
        {!imageLoaded && <div className={`${className} rounded-full bg-dark-3`} />}
      </div>
    )
  }

  const getTokenIcon = (symbol: string) => {
    const iconPath = WALLET_ICONS[symbol.toUpperCase()]
    if (iconPath) {
      return renderImage(iconPath, symbol)
    }
    if (isUrlImage(symbol) || symbol.startsWith('/images')) {
      return renderImage(symbol, name || 'Optimex')
    }
    return <div className={`${className} rounded-full bg-dark-3`} />
  }

  return getTokenIcon(symbol)
}

export default TokenIcon
